import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import {
	logNS,
	logSlice,
	organizationSelector,
	logApi,
	ADVERTISEMENT_TAB,
} from 'Pages/advertisement'

function* getLogs(action: logNS.GetLogs) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const tab = yield* select(organizationSelector.selectActiveTab)
		const res = yield* call(logApi.getLogs, action.payload, tab)
		yield* put(logSlice.actions.setLogs(res))
		if (tab === ADVERTISEMENT_TAB.CREATIVES) {
			const res = yield* call(logApi.getLogsAdriver, action.payload, tab)
			yield* put(logSlice.actions.setLogsAdriver(res))
		}
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* logsSaga() {
	yield* takeLatest(logSlice.actions.getLogs.type, getLogs)
}
